<div class="wizard d-flex position-fixed py-3" [class.has-border]="scrolling">
    <div class="wizard-step" *ngFor="let step of steps; let i = index; let last = last" [style.width]="step.width" [ngClass]="{ 'active-step': i <= currStep, 'current-step': i === currStep }">
        <div class="step-desc d-flex align-items-center flex-column">
            <div class="step-number d-flex align-items-center justify-content-center mb-2 border rounded-circle">{{i + 1}}</div>
            <div class="step-name">{{step.name}}</div>
        </div>
        <div *ngIf="!last" [ngClass]="{ 'step-line position-absolute': true, 'bg-light': !step.done, 'bg-danger': step.done }">
            <div *ngIf="i === currStep" class="bg-danger" [style.width]="step.percentage ? (step.percentage + '%') : '0'"></div>
        </div>
    </div>
</div>

<router-outlet></router-outlet>
